import React from 'react'
import { Alert, Button, Card, Descriptions, Divider, Form, Input, message } from 'antd'

import { useAuth } from '@/context/AuthContext'
import { authApi } from '@/services/authApi'

function ProfilePage() {
  const { user, refreshMe } = useAuth()
  const [form] = Form.useForm()
  const [loading, setLoading] = React.useState(false)
  const [passwordLoading, setPasswordLoading] = React.useState(false)

  React.useEffect(() => {
    if (!user) return
    form.setFieldsValue({
      username: user.username,
      full_name: user.full_name,
      phone: user.phone,
    })
  }, [user, form])

  const submit = async (values: { full_name: string; phone?: string }) => {
    setLoading(true)
    try {
      await authApi.updateProfile(values)
      await refreshMe()
      message.success('个人资料已更新')
    } catch (error: any) {
      message.error(error?.response?.data?.detail || '保存失败')
    } finally {
      setLoading(false)
    }
  }

  const changePassword = async (values: { current_password: string; new_password: string; confirm_password: string }) => {
    if (values.new_password !== values.confirm_password) return message.error('两次输入的新密码不一致')
    setPasswordLoading(true)
    try {
      await authApi.changePassword(values.current_password, values.new_password)
      message.success('密码已修改，请重新登录')
      window.setTimeout(() => { localStorage.removeItem('cbms_token'); window.location.replace('/login/admin') }, 800)
    } catch (error: any) { message.error(error?.response?.data?.detail || '密码修改失败') }
    finally { setPasswordLoading(false) }
  }

  return (
    <Card title="个人资料与账号安全" style={{ maxWidth: 760 }}>
      {user?.must_change_password && <Alert type="warning" showIcon message="当前仍是管理员设置的初始密码，请立即修改。" style={{ marginBottom: 16 }} />}
      <Descriptions column={1} bordered size="small" style={{ marginBottom: 20 }} items={[
        { key: 'account', label: '登录号', children: user?.username },
        { key: 'organization', label: '组织归属', children: user?.organization_path?.join(' / ') || '未分配' },
        { key: 'manager', label: '直属领导', children: user?.manager_name || '未设置' },
        { key: 'role', label: '角色', children: user?.is_admin ? '系统管理员' : user?.is_organization_leader ? '组织负责人' : '员工' },
      ]} />
      <Form form={form} layout="vertical" onFinish={submit}>
        <Form.Item label="用户名" name="username">
          <Input disabled />
        </Form.Item>
        <Form.Item label="姓名" name="full_name" rules={[{ required: true, message: '请输入姓名' }]}>
          <Input />
        </Form.Item>
        <Form.Item label="电话" name="phone" rules={[{ required: true, message: '请输入电话' }]}>
          <Input />
        </Form.Item>
        <Button type="primary" htmlType="submit" loading={loading}>保存资料</Button>
      </Form>
      <Divider>修改密码</Divider>
      <Form layout="vertical" onFinish={changePassword}>
        <Form.Item label="当前密码" name="current_password" rules={[{ required: true }]}><Input.Password /></Form.Item>
        <Form.Item label="新密码" name="new_password" rules={[{ required: true }, { min: 8, message: '密码至少 8 位' }]}><Input.Password /></Form.Item>
        <Form.Item label="确认新密码" name="confirm_password" rules={[{ required: true }]}><Input.Password /></Form.Item>
        <Button type="primary" danger htmlType="submit" loading={passwordLoading}>修改密码并重新登录</Button>
      </Form>
    </Card>
  )
}

export default ProfilePage
